'use client';
import { LANGUAGE_NAMES, LOCALES, isLocale, localizeHref } from '@/lib/i18n/core';
import { useI18n } from './LocaleProvider';
import './languages.css';
export default function LanguageSelector() {
  const { locale, t } = useI18n();
  return <label className="rdv-language-selector"><span aria-hidden="true">◎</span><span className="rdv-language-label">{t('Langue du site')}</span><select aria-label={t('Langue du site')} value={locale} onChange={event => {
    const next = event.target.value;
    if (!isLocale(next)) return;
    document.cookie = 'rdv_locale=' + next + ';path=/;max-age=31536000;samesite=lax' + (location.protocol === 'https:' ? ';secure' : '') + (/(^|\.)rdvpartners\.fr$/.test(location.hostname) ? ';domain=rdvpartners.fr' : '');
    location.assign(localizeHref(location.pathname + location.search + location.hash, next));
  }}>{LOCALES.map(language => <option key={language} value={language} lang={language}>{LANGUAGE_NAMES[language]}</option>)}</select></label>;
}
